import React from 'react';
import './CustomLoader.css';

const CustomLoader = ({ size = 24, className = '', color = '#FF5526', style = {} }) => {
    return (
        <div className={`custom-loader-wrapper ${className}`} style={{ width: size, height: size, ...style }}>
            <div className="loader-ring" style={{ borderTopColor: color }} />
            <div className="loader-glow" style={{ backgroundColor: color }} />
        </div>
    );
};

export default CustomLoader;
